import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { siteContent } from '../data/siteContent';
import { SocialIcon } from './SitePrimitives';
import WhatsAppIcon from './WhatsAppIcon';

const Footer = () => {
    const { language } = useLanguage();
    const content = siteContent[language];

    return (
        <footer className="border-t border-brown-50/10 bg-brown-25 px-5 py-12 text-center text-brown-50">
            <Link to="/home" aria-label="Neuroptimisme home">
                <img src="/assets/logo2.png" alt="Neuroptimisme" className="mx-auto h-28 w-28 object-contain" />
            </Link>
            <div className="mt-6 flex items-center justify-center gap-3">
                <SocialIcon href={content.social.linkedin} label="LinkedIn">
                    <img src="/assets/icons/linkedin.png" alt="" className="h-8 w-8 object-contain" />
                </SocialIcon>
                <SocialIcon href={content.social.instagram} label="Instagram">
                    <img src="/assets/icons/instagram.png" alt="" className="h-8 w-8 object-contain" />
                </SocialIcon>
                <SocialIcon href={content.social.whatsapp} label="WhatsApp">
                    <WhatsAppIcon className="h-6 w-6" />
                </SocialIcon>
            </div>
            <a href={content.social.whatsapp} target="_blank" rel="noopener noreferrer" className="mt-5 inline-block text-sm underline underline-offset-4">
                WhatsApp · {content.social.whatsappLabel}
            </a>
            <div className="mx-auto mt-9 h-px max-w-5xl bg-white/70" />
            <p className="mt-7 text-sm">© {new Date().getFullYear()} Neuroptimisme · {content.footer.rights}</p>
            <p className="mt-3 text-xs text-brown-50/70">
                {content.footer.madeBy}{' '}
                <a href="https://alfirma.com" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2">Al Firma</a>
            </p>
            <a href="mailto:contact@neuroptimisme.fr" className="mt-3 inline-block text-xs underline underline-offset-2">contact@neuroptimisme.fr</a>
        </footer>
    );
};

export default Footer;
